<script setup lang="ts">
const route = useRoute();

const title = ':PtBurg* • Арт студия • Дизайн и разработка';
const description = 'Создаем решения реального времени c 3D и анимацией. Интернет – это искусство.';
const siteUrl = 'https://ptburg.com';
const canonicalUrl = computed(() => `${siteUrl}${route.path}`);

useMeta(() => ({
  title,
  meta: {
    description: { name: 'description', content: description },

    // Open Graph
    ogTitle: { property: 'og:title', content: title },
    ogDescription: { property: 'og:description', content: description },
    ogImage: { property: 'og:image', content: `${siteUrl}/og-image.png` },
    ogUrl: { property: 'og:url', content: canonicalUrl.value },
    ogType: { property: 'og:type', content: 'website' },
    ogSiteName: { property: 'og:site_name', content: 'PtBurg' },
    ogLocale: { property: 'og:locale', content: 'ru_RU' },

    // Twitter Cards
    twitterCard: { name: 'twitter:card', content: 'summary_large_image' },
    twitterTitle: { name: 'twitter:title', content: title },
    twitterDescription: { name: 'twitter:description', content: description },
    twitterImage: { name: 'twitter:image', content: `${siteUrl}/og-image.png` },

    // SEO
    robots: { name: 'robots', content: 'index, follow' },
  },
  link: {
    canonical: { rel: 'canonical', href: canonicalUrl.value },
  },
}));
</script>

<template lang="pug">
q-page.overflow-hidden
  Suspense
    template(#fallback)
      LoadingSkeleton(bg-color="#c5aaff")
    TreIndex
  .contacts(v-if="route.name === 'contacts'")
    //- q-form
    EmailLink
    TelegramLink
</template>
